// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","wrapper":"searchFilterCategory_wrapper__EsZAA","header":"searchFilterCategory_header__FtQ57"};